// extracted by mini-css-extract-plugin
export var arrows = "_52-5";
export var decrementer = "_52-9";
export var disabled = "_52-3";
export var error = "_52-1";
export var hiddenText = "_52-a";
export var incrementer = "_52-8";
export var input = "_52-7";
export var inputWrapper = "_52-0";
export var leadingIcon = "_52-b";
export var readonly = "_52-2";
export var regular = "_52-6";
export var small = "_52-4";